import {FileOperationView, InstallerBridge} from '../installerBridge';
import {createClassLogger, Logger} from '../../utils/Logging';

const logger: Logger = createClassLogger('InstallerBridge:Mock');

const installerMock: InstallerBridge = {
    setFileOperationView: async (view: FileOperationView): Promise<void> => {
        logger.info('setFileOperationView', 'MOCKED, with simulated response', {view});
    },

    subscribe: async (event: string): Promise<number> => {
        logger.info('subscribe', 'MOCKED, with simulated response', {event});
        return Math.floor(Math.random() * 1000);
    },

    unsubscribe: async (subscriptionId: number): Promise<boolean> => {
        logger.info('unsubscribe', 'MOCKED, with simulated response', {subscriptionId});
        return false;
    }
};

export default installerMock;
